import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentSearchIcon = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor = '#212121', ...props }, ref) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
      ref={ref}
    >
      <Path
        d='M10 2.75a7.25 7.25 0 015.63 11.819l4.9 4.9a.75.75 0 01-.976 1.134l-.084-.073-4.901-4.9A7.25 7.25 0 1110 2.75zm0 1.5a5.75 5.75 0 100 11.5 5.75 5.75 0 000-11.5z'
        fill={fillColor}
      />
    </Svg>
  )
)

FluentSearchIcon.displayName = 'FluentSearchIcon'

export default FluentSearchIcon
